// @flow
import { Record } from "immutable";

export type EventHost = {
  id?: string,
  userId?: string,
  firstName: string,
  lastName: string,
};

export type EventRecordI = {
  id: string,
  name: string,
  url: string,
  status: string,
  reviewStatus: string,
  createdBy: string,
  price: number,
  registrantCount: number,
  capacity: number,
  timezone: string,
  venueName: string,
  address1: string,
  city: string,
  state: string,
  hasLiveFire: boolean,
  hostAttendeeId: ?string,
  hosts: Array<EventHost>,
  startDate: string,
  endDate: string,
  set: (key: string, value: mixed) => EventRecordI,
  toJS: () => { [string]: mixed },
};

const EventRecord = Record({
  id: "",
  name: "",
  url: "",
  status: "",
  reviewStatus: "",
  createdBy: "",
  price: 0,
  registrantCount: 0,
  capacity: 0,
  timezone: "",
  venueName: "",
  address1: "",
  city: "",
  state: "",
  hasLiveFire: false,
  hostAttendeeId: null,
  hosts: [],
  startDate: "",
  endDate: "",
});

export default EventRecord;
